/**
 * GA4 helpers for admin → same property as webapp (G-C922C1BE1C).
 * Used so Accept-order upgrades land on the customer user_id timeline.
 * Lazy-loads gtag once; no-op in development.
 */

export const WEBAPP_GA4_MEASUREMENT_ID = 'G-C922C1BE1C'

let gaReadyPromise = null

const canTrack = () =>
	typeof window !== 'undefined' && process.env.NODE_ENV !== 'development'

const ensureGtag = () => {
	if (!canTrack()) return Promise.resolve(false)
	if (typeof window.gtag === 'function' && window.__wmAdminGaReady) {
		return Promise.resolve(true)
	}
	if (gaReadyPromise) return gaReadyPromise

	gaReadyPromise = new Promise((resolve) => {
		window.dataLayer = window.dataLayer || []
		if (typeof window.gtag !== 'function') {
			window.gtag = function gtag() {
				window.dataLayer.push(arguments)
			}
		}
		window.gtag('js', new Date())
		window.gtag('config', WEBAPP_GA4_MEASUREMENT_ID, {
			send_page_view: false,
		})

		const existing = document.querySelector(
			`script[src*="googletagmanager.com/gtag/js?id=${WEBAPP_GA4_MEASUREMENT_ID}"]`
		)
		if (existing) {
			window.__wmAdminGaReady = true
			resolve(true)
			return
		}

		const script = document.createElement('script')
		script.async = true
		script.src = `https://www.googletagmanager.com/gtag/js?id=${WEBAPP_GA4_MEASUREMENT_ID}`
		script.onload = () => {
			window.__wmAdminGaReady = true
			resolve(true)
		}
		script.onerror = () => resolve(false)
		document.head.appendChild(script)
	})

	return gaReadyPromise
}

/**
 * @param {string} eventName
 * @param {object} [params]
 * @param {{ userId?: string|number }} [opts]
 */
export const trackAdminGaEvent = async (eventName, params = {}, opts = {}) => {
	if (!eventName || !canTrack()) return
	const ready = await ensureGtag()
	if (!ready || typeof window.gtag !== 'function') return

	if (opts.userId != null && opts.userId !== '') {
		window.gtag('set', { user_id: String(opts.userId) })
	}

	window.gtag('event', eventName, {
		platform: 'admin',
		...params,
	})
}

/**
 * Fire when admin Accept upgrades a user to Premium.
 * @param {{ userID?: number|string, orderID?: number|string, subscriptionCode?: string, method?: string, transactionID?: string }} order
 */
export const trackSubscriptionActivated = (order = {}) => {
	const userId = order.userID
	if (!userId) return

	return trackAdminGaEvent(
		'subscription_activated',
		{
			plan_code: order.subscriptionCode || '',
			payment_method: order.method || '',
			transaction_id: String(
				order.transactionID || order.orderID || ''
			).slice(0, 100),
			activation_source: 'admin_accept',
			tag: 'subscription',
		},
		{ userId }
	)
}
